import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import GlobalHeader from '../components/Basic/Global/Header';



const routerMaker = ({ routes, rootUrl, defaultPage, isPublic }) => () => {

    const location = useLocation()
    const { accesses, role } = useSelector((state) => state.user);


    const filteredRoutes = routes.filter(t => {
        // return accesses[rootUrl]?.[t.path.includes('/:') ? t.path.slice(0, t.path.indexOf('/:')) : t.path] || (role === 'owner') || isPublic
        return accesses[rootUrl]?.[t.path] || (role === 'owner') || isPublic
    })
    const startPage = filteredRoutes.find(r => r.path === defaultPage)?.path || filteredRoutes[0]?.path
    // console.log('1111', rootUrl, defaultPage, routes, filteredRoutes)
    // if (filteredRoutes.length === 0) return <></>

    return (
        <>
            <GlobalHeader
                rootUrl={rootUrl}
                tabs={filteredRoutes?.filter(r => !r.isNotHeaderPage)}
            />
            <Routes>
                <Route>
                    {filteredRoutes?.map(router =>
                        <Route
                            key={router.path}
                            path={`/${router.path}`}
                            element={router.element}
                        >
                            {router.nestedRouter}
                        </Route>
                    )}
                    {filteredRoutes?.length === 0 ?
                        (
                            <Route path="*" element={<Navigate to='/user/profile' replace />} />
                        ) :
                        (<>
                            <Route path="*" element={<Navigate to={location.pathname !== `/${rootUrl}/` ? location.pathname : `/${rootUrl}/${startPage}`} replace />} />
                            <Route path="" element={<Navigate to={location.pathname !== `/${rootUrl}/` ? location.pathname : `/${rootUrl}/${startPage}`} replace />} />
                        </>)
                    }
                </Route>
            </Routes>

        </>
    )
}

export default routerMaker


// const routerMaker = ({ routes, rootUrl, defaultPage }) => {


//     return (
//         <Route path={`/${rootUrl}`} element={
//             <>
//                 <Header
//                     rootUrl={rootUrl}
//                     tabs={routes.filter(r => !r.isNotHeaderPage)}
//                 />
//                 <Outlet />
//             </>
//         }>
//             {routes.map(router =>
//                 <Route
//                     key={router.path}
//                     path={router.path}
//                     element={router.element}
//                 >
//                     {router.nestedRouter}
//                 </Route>
//             )}
//             <Route path="*" element={<Navigate to={`/${rootUrl}/${defaultPage}`} replace />} />
//             <Route path="" element={<Navigate to={`/${rootUrl}/${defaultPage}`} replace />} />
//         </Route>
//     )
// }



